import React from "react";
import ReactDOM from "react-dom";
import { registerServiceWorker } from "./serviceWorker";
import App from "./App";
// styles
import 'styles/custom-properties.css';
import "./index.css";
import "antd/dist/antd.css"; // or 'antd/dist/antd.less'
import "styles/custom.css";
import './i18n';

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
registerServiceWorker();
